import { render, staticRenderFns } from "./TypeIndex.vue?vue&type=template&id=22ba2abb"
import script from "./TypeIndex.vue?vue&type=script&lang=js"
export * from "./TypeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports